import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { userActivation } from '../redux/actions/auth';

import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { Alert, AlertTitle } from '@mui/material';
import { CircularProgress } from '@mui/material';

const VerifyEmail = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get('verifyEmailToken');
  const [activation, setActivation] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { message } = useSelector((state) => state.authMessage);

  useEffect(() => {
    dispatch(userActivation(token))
      .then(() => {
        setActivation(true);
        setTimeout(() => setLoading(true), 3000);
      })
      .catch(() => {
        setActivation(false);
        setTimeout(() => setLoading(true), 3000);
      });
  }, [token]);

  if (loading) {
    navigate('/');
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {' '}
        <CircularProgress />
        <div>Yönlendiriliyor...</div>
        <Alert severity="success">
          <AlertTitle>Bilgi</AlertTitle>
          <strong>Kullanıcı hesabınız başarı ile aktifleştirildi...</strong>
        </Alert>
        {message && (
          <Alert severity={message.type}>
            <AlertTitle>Bilgi</AlertTitle>
            <strong>{message.message}</strong>
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default VerifyEmail;
